import { Component, Input, ViewChild, Output, EventEmitter, ViewEncapsulation, ViewChildren, QueryList, ChangeDetectorRef, SimpleChange, OnInit, OnChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ExportDataService } from '../../../../shared/services/export-data.service';
import { MatTable, MatTableDataSource, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterCellDef, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { Sort, MatSort, MatSortHeader } from '@angular/material/sort';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { Location, NgClass, CurrencyPipe } from '@angular/common';
import { CustomNumbersAutofilterComponent } from '../../../../shared/components/custom-numbers-autofilter/custom-numbers-autofilter.component';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatSelectionList, MatListOption } from '@angular/material/list';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { OptumTechLabourComponent } from '../optum-tech-labour/optum-tech-labour.component';
import { EditUcmgComponent } from '../edit-ucmg/edit-ucmg.component';
import { ViewCommentsComponent } from '../view-comments/view-comments.component';
import { SearchPipe } from '../../../../shared/pipe/search.pipe';

@Component({
    selector: 'app-capital-maintenance-table',
    templateUrl: './capital-maintenance-table.component.html',
    styleUrl: './capital-maintenance-table.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ])
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, LoaderComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatMenuTrigger, MatMenu, MatInput, FormsModule, MatSelectionList, MatListOption, CustomNumbersAutofilterComponent, MatCellDef, MatCell, MatIconButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterCellDef, MatFooterRowDef, MatFooterRow, AppModalComponent, OptumTechLabourComponent, EditUcmgComponent, ViewCommentsComponent, CurrencyPipe, SearchPipe]
})
export class CapitalMaintenanceV4Component implements AfterViewInit, OnChanges, OnDestroy, OnInit {
  @Input() ucmgListTable = false;
  @Input() COLUMNS: any[] = ["Group Name", "Group Type", "No Of Applications", "Visibility", "Action"];
  @Input() SCHEMA;
  @Input() filterSegment;
  fundSegment: any;
  @Input() TABLE_CONFIG;
  @Input() SORT_CONFIG: Sort;
  @Input() currentTable: string;
  @Input() searchedUcmgId: string;
  @Input() ucmgView:string;
  @Input() leadersData:string;
  @Input() ucmgYear:any;
  @Input() selectedStatusList:any;
  @Input() set searchField(value: string) {
    this.searchedText = value;
  }
  @Input() searchedText:string;
  @ViewChild('editUcmgModal',  { static: false }) editUcmgModal;
  @ViewChild('viewCommentsModal', {static: false}) viewCommentsModal;
  @ViewChild('OptumModal') OptumModal;
  @Input() expanded_columns: any[] = ["UCMG ID","UCMG Name","ACAP","Leader Run Rate","Optum Tech Labor","Advisory Services", "Business Labor", "Hardware/Software", "Other Chargebacks", "Professional Fees"];

  @ViewChild(MatPaginator,  { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  @ViewChildren('childpagination') childpaginator: QueryList<MatPaginator>;
  @ViewChild('ListTablepaginator') ListTablepaginator: MatPaginator;
  @Input() dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() ucmgListDataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() expandAll: string = 'false';
  @Input() exportToExcel: number;
  @Input() segData:any;
  @Output() dataRefresh: EventEmitter<any> = new EventEmitter();
  @Output() reloadData: EventEmitter<any> = new EventEmitter();
  @Output() paginationClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() checkClick: EventEmitter<any> = new EventEmitter();
  @Output() checkBoxEvent: EventEmitter<any> = new EventEmitter();
  @Output() filteredDataChange: EventEmitter<any[]> = new EventEmitter();

  @Input() pageSize: Array<number>;
  @Input() yearList:any = [];
  @ViewChildren('customNumbersAutoFilter') customNumbersAutoFilters: QueryList<CustomNumbersAutofilterComponent>;
  private subject: Subject<string> = new Subject();

  currentYear = new Date().getUTCFullYear();
  editExpandDataSource = [];
  reloadOnReopen: boolean = false;
  displayedColumns: any[] = [];
  displayedChildColumns: any[];
  dataSchema;
  dataFilter;
  editUcmgData:any;
  ucmgData:any;
  originalDataFilter;
  paduapplyFlag:boolean = false;
  ucmgId:string;
  ucmgName:string;
  ucmgOwner:string;
  ucmgAvailableOT: string;
  UCMG_Owner_MSID:string;
  clonedData:any;
  optumData:any;
  isEditUcmg:boolean =false;
  isViewComments:boolean = false;
  selection = new SelectionModel<any>(true, []);
  subFilters : any;
  expandedElement;
  addCapability;
  selectedRow: any;
  selectedIndex: any;
  expandElements = [];
  public showLoader: boolean = false;
  //filters
  Allfilter = [];
  AllSubfilter = [];
  ucmgIdNameFilter: any[];
  FundingSourceFilter = [];
  SegmentFilter = [];
  LobFilter = [];
  SubLobFilter = [];
  SubLobID = []
  ChiefArchitectFilter = [];
  ArchitectDelegateFilter = [];
  fundingOwnerFilter = [];
  totalACAPFilter: any[];
  acapFilter = [];
  otlFilter = [];
  otVarianceFilter = [];
  advisoryServiceFilter = [];
  businessLaborFilter = [];
  hardwareSoftwareFilter = [];
  otherChargebacksFilter = [];
  professionalFeesFilter = [];
  leaderOTAllocationFilter = [];
  leaderOTActualsFilter = [];
  totalOTFilter: any[];
  totalRunRateFilter: any[];
  //filters applied
  FundingSourceFilterApplied = false;
  SegmentFilterApplied = false;
  FundingSegmentFilterApplied = false;
  FundingOwnerFilterApplied = false;
  ucmg_countFilterApplied = false;
  acapFilterApplied: boolean = false;
  totalRunRateFilterApplied: boolean = false;

  otlFilterApplied: boolean = false;
  otVarianceFilterApplied: boolean = false;
  advisoryServiceFilterApplied: boolean = false;
  businessLaborFilterApplied: boolean = false;
  hardwareSoftwareServiceApplied: boolean = false;
  otherChargebacksFilterApplied: boolean = false;
  professionalFeesFilterApplied: boolean = false;
  leaderOTAllocationApplied: boolean = false;
  leaderOTActualsFilterApplied: boolean = false;
  flagged_ucmg_countFilterApplied: boolean = false;
  totalACAPFilterApplied: boolean = false;
  totalOTFilterApplied: boolean = false;
  ucmgIdNameFilterApplied: boolean  = false; 
  ucmgNameFilterApplied : boolean = false;
  ChiefArchitectFilterApplied : boolean[] = [false];
  ArchitectDelegateFilterApplied : boolean[] = [false];
  AllArchitectDelegates = [];
  filValue = [];
  filSubValue = [];
  filterList: any = [];
  searchValue: string;
  selectedLob: any;
  searchTxt = '';
  searchSubTxt = '';
  inputElement:any;
  olddatasource: any[];
  oldChildDataSource: any[];
  previousSelection = [];
  allRowsExpanded: boolean = false;
  selectedChildTableIndex: number;
  @Output() collapseAll: EventEmitter<any> = new EventEmitter();
  @Output() columnDataSubLob: EventEmitter<any> = new EventEmitter();
  @Output() ColomnDataLob: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent:EventEmitter<any> = new EventEmitter(); 
  @Output() loadDeletePopup: EventEmitter<any> = new EventEmitter();
  restrictionInvesterEdit:boolean = false;
  newevent:any;
  fiscalYear:any;
  clearInputs:boolean = false;
  investmentStatus:any;
  ucmg_countFilter: any[];
  flagged_ucmg_countFilter: any[];
  ucmgNameFilter: any[];
  ucmgDisableData: any = [];
  ucmgCountValues: number[] = [];
  canEditPortfolioManager : boolean = false;
  canEditUCMGOwner : boolean = false;
  editUCMGUserRole: string = '';
  filterLists: any = [];
  tableFilterIndicies = {}

  constructor(
    private capabilityService: CommonModelService,
    public exportService: ExportDataService,
    public dialog: MatDialog,
    public maintenanceService: MaintenanceService,
    private readonly toaster: ToastrService,
    private readonly cd: ChangeDetectorRef,
    private router: Router, private location: Location,
    private sharedAuthService: SharedAuthService,
  ) {

  }

  ngOnInit() {
    this.fundOwnerRestrictionEdit();
    this.displayedColumns = this.COLUMNS.map(element => element.key);
    this.displayedChildColumns = this.expanded_columns.map(element => element.key);
    this.inputElement = '';
    this.dataSchema = this.SCHEMA;
    this.selectedRow = '';

    if(this.dataSource) {
      this.olddatasource = this.dataSource.data;
      this.dataSource.paginator = this.ucmgListTable ?  this.ListTablepaginator: this.paginator;
    }
    if (this.TABLE_CONFIG) {
      if (this.TABLE_CONFIG.FILTER_OPTIONS) {
        this.dataFilter = this.TABLE_CONFIG.FILTER_OPTIONS;
        this.originalDataFilter = JSON.parse(JSON.stringify(this.TABLE_CONFIG.FILTER_OPTIONS));
      }
    }

    this.subject.pipe(
      debounceTime(500)
    ).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });
  }
  
  ngAfterViewInit() {
    if (this.dataSource) {
      this.olddatasource = this.dataSource.data;
      this.dataSource.paginator = this.ucmgListTable ? this.ListTablepaginator : this.paginator;
      this.dataSource.sort = this.sort; // Ensure MatSort is linked to the dataSource// Debugging log
    }
  }

  ngOnDestroy() {
    if (typeof this.addCapability != 'undefined') {
      this.addCapability.unsubscribe();
    }
  }

  getAggregatedData(aggData){
    let sum=0; 
    aggData.forEach(a => sum += a.ACAP); 
    return sum 
  }

  viewComments(event) {
    this.ucmgData = JSON.parse(JSON.stringify(event));
    this.isViewComments = true;
    this.viewCommentsModal.show();
    const element =<any>document.querySelector('.nav-color');
    if(element){element.style.zIndex=1;}
  }

  deleteDemand(demand) {
    const id = demand.UCMG_ID;
    if (!id) {
      alert('Leader not found');
      return;
    }
    else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '400px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.minHeight = '200px';
      dialogConfig.height = 'auto';
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus=false;
      dialogConfig.data = {
        title: 'Are you sure to delete the selected UCMG?',
        buttonName: 'Delete',
        isOptum:true
      };

      const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result.data === 'save') {

          this.showLoader = true;
          const payload = {
            ucmg_id: id,
            fiscalYear: demand.fiscalYear
          }
          this.maintenanceService.deleteCapitalDemand(payload).subscribe(res => {
            if (res['Message'] == 'Capital Demand UCMG ID deleted successfully') {
              this.toaster.success(res.Message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
              this.showLoader = false;
              this.reloadData.emit();
            }
            else {
              this.toaster.error(res.Message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
              this.showLoader = false;
            }
          }, err => {
            console.log(err)
            this.showLoader = false;
            this.reloadData.emit();
            this.toaster.error(err.error?.errors, '', { timeOut: 10000, positionClass: 'toast-top-center' });
          })

        }
      });

    }
  }
 
  optumTechModal(ucmgValue) {
    this.ucmgId = ucmgValue.UCMG_ID;
    this.ucmgAvailableOT = ucmgValue.Optum_Tech_Labour;
    this.ucmgName = ucmgValue.UCMG_Name;
    this.ucmgOwner = ucmgValue.UCMG_Owner_Name || 'No Mapping';
    this.fiscalYear = ucmgValue.fiscalYear;
    this.clearInputs = !this.clearInputs;
    this.investmentStatus = ucmgValue.investmentStatus
    this.UCMG_Owner_MSID = ucmgValue.UCMG_Owner_MSID;
    this.postUCMGDisableCheck(this.ucmgId);
    this.OptumModal.show();
    this.fundSegment = ucmgValue.Funding_SegmentID;
    const element =<any>document.querySelector('.nav-color');
    if(element){element.style.zIndex=1;}
  }

  postUCMGDisableCheck(ucmgId:any) {
    const payload = {
      'UCMG_ID': ucmgId,
      'fisclYr': this.fiscalYear
    };
    this.maintenanceService.ucmgDisableCheck(payload).subscribe({
      next: (res) => {
        if (res.status===400) {
          this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log(res)
          console.log('ERROR Adding Leader response');
        }else{
          this.ucmgDisableData = res;
        }
      },
      error: (err) => {
        this.toaster.error('Error checking UCMG disabled status', '', {
          timeOut: 10000, positionClass: 'toast-top-center' 
        });
        console.error(err);
      }
    });
  }
 
  refreshEditdData(event){
    if(event) {
      this.editUcmgModal.hide();
      this.viewCommentsModal.hide();
      this.dataRefresh.emit(event);
   }
  }

  ngOnChanges(changes: { [expandAll: string]: SimpleChange }) {
    if (changes['COLUMNS'] || changes['expanded_columns']) {
      this.displayedColumns = (this.COLUMNS || []).map(element => element.key);
      this.displayedChildColumns = (this.expanded_columns || []).map(element => element.key);
    }
    if (this.sort) {
      this.dataSource.sort = this.sort; // Linking MatSort to dataSource here ensures sorting works after input changes (e.g., after export or data refresh)
    }
    this.fundOwnerRestrictionEdit();
    if(changes['exportToExcel']) {
      if(changes['exportToExcel']['previousValue']) {
        this.exportToCsv();
      }
    }
    if(changes['dataSource']) {
      if(changes['dataSource']['previousValue']) { 
        this.dataSource.paginator = this.ucmgListTable ?  this.ListTablepaginator: this.paginator;
      }
    }

    if(this.ucmgView === 'leaderView'){
      // Sort the dataSource by Funding_Segment
      this.dataSource.data.sort((a, b) => {
      const segmentA = a['Funding_Segment']?.toLocaleLowerCase() || '';
      const segmentB = b['Funding_Segment']?.toLocaleLowerCase() || '';
      return segmentA.localeCompare(segmentB);
      });
    }

  }

  closeEditModal(type){
    this.editUcmgModal.closeModal.subscribe((isClosed:boolean)=>{
     if(isClosed && type === 'editUcmg') {
      this.editUcmgData = JSON.parse(JSON.stringify(this.editUcmgData));
     }
    })
  }
 
  showpopup() {
    window.open(environment.docUrl+'user-guide/Capital-Demand/#optum-tech-labor-split');
  }

  sortData(event: { active: string; direction: string }): void {
    try {
      let sort: any[] = [];
      if (event && event.direction) {
        sort = [[event.active, event.direction]];
      }
      this.sortChangeEvent.emit(sort);
    } catch (error) {
      // Log error or handle gracefully
      console.error('Error in sortData:', error);
    }
  }

  checkPrevious(event,prevArr:any = []) {
    this.previousSelection = prevArr;
    const filterList:Array<any> = [...this.filterLists];
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (filterList.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (filterList.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }

  selectionChange(event, column) {
    if (column.key == 'Funding_SegmentID') {
      this.filtervaluesLogic(event,'Funding_SegmentID', 'SegmentFilter', this.tableFilterIndicies['Funding_SegmentID']);
    }
    if (column.key == 'Funding_Segment') {
      this.filtervaluesLogic(event,'Funding_Segment', 'LobFilter', this.tableFilterIndicies['Funding_Segment']);
    }
    if (column.key == 'Funding_Owner') {
      this.filtervaluesLogic(event,'Funding_Owner', 'fundingOwnerFilter', this.tableFilterIndicies['Funding_Owner']);
    }
    if (column.key == 'UCMG_ID_Name') {
      this.filtervaluesLogic(event,'UCMG_ID_Name', 'ucmgIdNameFilter', this.tableFilterIndicies['UCMG_ID_Name']);
    }
    if (column.key == 'Funding_Source') { // Add Funding_Source logic
      this.filtervaluesLogic(event,'Funding_Source', 'FundingSourceFilter', this.tableFilterIndicies['Funding_Source']);
    }
    if (column.key == 'ucmg_count') { // Add UCMG_Count logic
      this.filtervaluesLogic(event,'ucmg_count', 'ucmg_countFilter', this.tableFilterIndicies['ucmg_count']);
    }
    if (column.key == 'flagged_ucmg_count') { // Add flagged_ucmg_count
      this.filtervaluesLogic(event,'flagged_ucmg_count', 'flagged_ucmg_countFilter', this.tableFilterIndicies['flagged_ucmg_count']);
    }
  }

  filtervaluesLogic(event, column_name, filterName, index){
    this.Allfilter.forEach((a, i) => { if (a.column == column_name) this.Allfilter.splice(i, 1) });
    const newevent = this.checkPrevious(event,this[filterName]);
    this[filterName] = newevent.source._value;
    this.Allfilter.push({ column: column_name, value: newevent.source._value }) 
  }

  numberFilterApply(evt){
    this.filtervaluesLogicFromNumbersFilter(evt);
  }
  
  filtervaluesLogicFromNumbersFilter(evt){
    try {
      switch(evt.column){
        case 'ucmg_count':
          this.filtervaluesLogic(evt, 'ucmg_count', 'ucmg_countFilter', this.tableFilterIndicies['ucmg_count']);
          break;
        case 'flagged_ucmg_count':
          this.filtervaluesLogic(evt, 'flagged_ucmg_count', 'flagged_ucmg_countFilter', this.tableFilterIndicies['flagged_ucmg_count']);
          break;
        case 'total_acap':
          this.filtervaluesLogic(evt, 'total_acap', 'totalACAPFilter', this.tableFilterIndicies['total_acap']);
          break;
        case 'total_OT':
          this.filtervaluesLogic(evt, 'total_OT', 'totalOTFilter', this.tableFilterIndicies['total_OT']);
          break;
        case 'ACAP':
          this.filtervaluesLogic(evt, 'ACAP', 'acapFilter', this.tableFilterIndicies['ACAP']);
          break;
        case 'totalRunRate':
          this.filtervaluesLogic(evt, 'totalRunRate', 'totalRunRateFilter', this.tableFilterIndicies['totalRunRate']);
          break;
        case 'Optum_Tech_Labour':
          this.filtervaluesLogic(evt, 'Optum_Tech_Labour', 'otlFilter', this.tableFilterIndicies['Optum_Tech_Labour']);
          break;
        case 'OT_Variance':
          this.filtervaluesLogic(evt, 'OT_Variance', 'otVarianceFilter', this.tableFilterIndicies['OT_Variance']);
          break;
        case 'Advisory_Service':
          this.filtervaluesLogic(evt, 'Advisory_Service', 'advisoryServiceFilter', this.tableFilterIndicies['Advisory_Service']);
          break;
        case 'Bussiness_Labour':
          this.filtervaluesLogic(evt, 'Bussiness_Labour', 'businessLaborFilter', this.tableFilterIndicies['Bussiness_Labour']);
          break;
        case 'Hardware_Software':
          this.filtervaluesLogic(evt, 'Hardware_Software', 'hardwareSoftwareFilter', this.tableFilterIndicies['Hardware_Software']);
          break;
        case 'Other_Chargebacks':
          this.filtervaluesLogic(evt, 'Other_Chargebacks', 'otherChargebacksFilter', this.tableFilterIndicies['Other_Chargebacks']);
          break;
        case 'Professional_Fees':
          this.filtervaluesLogic(evt, 'Professional_Fees', 'professionalFeesFilter', this.tableFilterIndicies['Professional_Fees']);
          break;
        case 'Leader_OT_Allocation':
          this.filtervaluesLogic(evt, 'Leader_OT_Allocation', 'leaderOTAllocationFilter', this.tableFilterIndicies['Leader_OT_Allocation']);
          break;
        case 'Leader_OT_Actuals':
          this.filtervaluesLogic(evt, 'Leader_OT_Actuals', 'leaderOTActualsFilter', this.tableFilterIndicies['Leader_OT_Actuals']);
          break;
      }
    } catch (error) {
    console.error('Error in filtervaluesLogicFromNumbersFilter:', error, evt);
    }
    this.applyLocalFilter();
  }

  applyLocalFilter() {
    this.dataSource.data = [...this.olddatasource];
    this.searchTxt = '';
    this.searchSubTxt ='';
    this.previousSelection = [];
   
    this.Allfilter.forEach((e1) => {
      if (e1.column == 'Funding_SegmentID') {
        this.localFilterLogic(e1.value,e1,'Funding_SegmentID', this.tableFilterIndicies['Funding_SegmentID'],'SegmentFilterApplied');
      }
      if (e1.column == 'Funding_Owner') {
        this.localFilterLogic(e1.value,e1,'Funding_Owner', this.tableFilterIndicies['Funding_Owner'],'FundingOwnerFilterApplied');
      }
      if (e1.column == 'Funding_Segment') {
        this.localFilterLogic(e1.value,e1,'Funding_Segment', this.tableFilterIndicies['Funding_Segment'],'FundingSegmentFilterApplied');
      }
      if (e1.column == 'Funding_Source') {
        this.localFilterLogic(e1.value, e1, 'Funding_Source', this.tableFilterIndicies['Funding_Source'], 'FundingSourceFilterApplied');
      }
      if (e1.column == 'UCMG_ID_Name' ) {
        this.localFilterLogic(e1.value,e1,'UCMG_ID_Name', this.tableFilterIndicies['UCMG_ID_Name'], 'ucmgIdNameFilterApplied');
      }
      if(e1.column == 'ucmg_count'){
        this.localFilterLogic(e1.value,e1,'ucmg_count', this.tableFilterIndicies['ucmg_count'], 'ucmg_countFilterApplied');
      }
      if(e1.column == 'flagged_ucmg_count'){
        this.localFilterLogic(e1.value,e1,'flagged_ucmg_count', this.tableFilterIndicies['flagged_ucmg_count'], 'flagged_ucmg_countFilterApplied');
      }
      if(e1.column == 'total_acap'){
        this.localFilterLogic(e1.value,e1,'total_acap', this.tableFilterIndicies['total_acap'], 'totalACAPFilterApplied');
      }
      if(e1.column == 'total_OT'){
        this.localFilterLogic(e1.value,e1,'total_OT', this.tableFilterIndicies['total_OT'], 'totalOTFilterApplied');
      }
      if(e1.column == 'totalRunRate'){
        this.localFilterLogic(e1.value,e1,'totalRunRate', this.tableFilterIndicies['totalRunRate'], 'totalRunRateFilterApplied');
      }
      if(e1.column == 'ACAP'){
        this.localFilterLogic(e1.value,e1,'ACAP', this.tableFilterIndicies['ACAP'], 'acapFilterApplied');
      }
      if(e1.column == 'Optum_Tech_Labour'){
        this.localFilterLogic(e1.value,e1,'Optum_Tech_Labour', this.tableFilterIndicies['Optum_Tech_Labour'], 'otlFilterApplied');
      }
      if(e1.column == 'OT_Variance'){
        this.localFilterLogic(e1.value,e1,'OT_Variance', this.tableFilterIndicies['OT_Variance'], 'otVarianceFilterApplied');
      }
      if(e1.column == 'Advisory_Service'){
        this.localFilterLogic(e1.value,e1,'Advisory_Service', this.tableFilterIndicies['Advisory_Service'], 'advisoryServiceFilterApplied');
      }
      if(e1.column == 'Bussiness_Labour'){
        this.localFilterLogic(e1.value,e1,'Bussiness_Labour', this.tableFilterIndicies['Bussiness_Labour'], 'businessLaborFilterApplied');
      }
      if(e1.column == 'Hardware_Software'){
        this.localFilterLogic(e1.value,e1,'Hardware_Software', this.tableFilterIndicies['Hardware_Software'], 'hardwareSoftwareServiceApplied');
      }
      if(e1.column == 'Other_Chargebacks'){
        this.localFilterLogic(e1.value,e1,'Other_Chargebacks', this.tableFilterIndicies['Other_Chargebacks'], 'otherChargebacksFilterApplied');
      }
      if(e1.column == 'Professional_Fees'){
        this.localFilterLogic(e1.value,e1,'Professional_Fees', this.tableFilterIndicies['Professional_Fees'], 'professionalFeesFilterApplied');
      }
      if(e1.column == 'Leader_OT_Allocation'){
        this.localFilterLogic(e1.value,e1,'Leader_OT_Allocation', this.tableFilterIndicies['Leader_OT_Allocation'], 'leaderOTAllocationApplied');
      }
      if(e1.column == 'Leader_OT_Actuals'){
        this.localFilterLogic(e1.value,e1,'Leader_OT_Actuals', this.tableFilterIndicies['Leader_OT_Actuals'], 'leaderOTActualsFilterApplied');
      }
    });
    if (this.Allfilter.length == 0) {
      this.dataSource = new MatTableDataSource(this.olddatasource);
      this.dataSource.paginator = this.ucmgListTable ?  this.ListTablepaginator: this.paginator;
      this.dataSource.sort = this.sort;
      // Emit original data when no filters are applied
      this.filteredDataChange.emit(this.olddatasource);
    } else {
      // Emit filtered data when filters are applied
      this.filteredDataChange.emit(this.dataSource.data);
    }
    this.closeOpenMenus();
  }

  localFilterLogic(value, element, column, index, filterName){
    let filterdata = this.dataSource.data;
      if(column == 'Funding_Owner') {
        filterdata = this.dataSource.data.filter((item) => element.value.some(e => item[column] && item[column].includes(e) == true));
      }else{
          filterdata = filterdata.filter((item) => element.value.some(e => e == item[column]));
      }
      this.filterLists = filterdata.map((item) => { return item[element] });
      this[filterName] = true;
      this.dataSource = new MatTableDataSource(filterdata);
      this.dataSource.paginator = this.ucmgListTable ?  this.ListTablepaginator: this.paginator;
      this.dataSource.sort = this.sort;
      if(this.trigger.toArray()[index].menuOpen){
        this.trigger.toArray()[index].closeMenu();
      }
      // Emit filtered data
      this.filteredDataChange.emit(filterdata);
  }

  getPageSizeOptions(length: number): number[] {
    const options = [];
    if (length > 30) {
      for (let i = 30; i <= length; i += 30) {
        options.push(i);
      }
      const nearestMultipleOf10 = Math.ceil(length / 10) * 10;
      if (!options.includes(nearestMultipleOf10)) {
        options.push(nearestMultipleOf10);
      }
    }
    return options;
  }

  private closeOpenMenus(): void {
    (this.trigger?.toArray?.() ?? []).forEach(t => {
      if (t?.menu && t.menuOpen) t.closeMenu();
    });
  }

  clearLocalFilter(column) {
    this.searchTxt = '';
    this.searchSubTxt = '';
    this.previousSelection = []
    this.closeOpenMenus();

    if (column.key == 'Funding_SegmentID') {
      this.SegmentFilter = [];
      this.SegmentFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_SegmentID') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Funding_Owner') {
      this.fundingOwnerFilter = [];
      this.FundingOwnerFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_Owner') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Funding_Segment') {
      this.LobFilter = [];
      this.FundingSegmentFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Funding_Segment') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Funding_Source') { // Add Funding_Source logic
      this.FundingSourceFilter = [];
      this.FundingSourceFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Funding_Source') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'UCMG_ID_Name') {
      this.ucmgIdNameFilter = [];
      this.ucmgIdNameFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'UCMG_ID_Name') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'ucmg_count') {
      this.ucmg_countFilter = [];
      this.ucmg_countFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'ucmg_count') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'flagged_ucmg_count') {
      this.flagged_ucmg_countFilter = [];
      this.flagged_ucmg_countFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'flagged_ucmg_count') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'total_acap') {
      this.totalACAPFilter = [];
      this.totalACAPFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'total_acap') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'total_OT') {
      this.totalOTFilter = [];
      this.totalOTFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'total_OT') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'totalRunRate') {
      this.totalRunRateFilter = [];
      this.totalRunRateFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'totalRunRate') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'ACAP') {
      this.acapFilter = [];
      this.acapFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'ACAP') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Optum_Tech_Labour') {
      this.otlFilter = [];
      this.otlFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Optum_Tech_Labour') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'OT_Variance') {
      this.otVarianceFilter = [];
      this.otVarianceFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'OT_Variance') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Advisory_Service') {
      this.advisoryServiceFilter = [];
      this.advisoryServiceFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Advisory_Service') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Bussiness_Labour') {
      this.businessLaborFilter = [];
      this.businessLaborFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Bussiness_Labour') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Hardware_Software') {
      this.hardwareSoftwareFilter = [];
      this.hardwareSoftwareServiceApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Hardware_Software') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Other_Chargebacks') {
      this.otherChargebacksFilter = [];
      this.otherChargebacksFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Other_Chargebacks') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Professional_Fees') {
      this.professionalFeesFilter = [];
      this.professionalFeesFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Professional_Fees') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Leader_OT_Allocation') {
      this.leaderOTAllocationFilter = [];
      this.leaderOTAllocationApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Leader_OT_Allocation') this.Allfilter.splice(i, 1) });
    }
    if (column.key == 'Leader_OT_Actuals') {
      this.leaderOTActualsFilter = [];
      this.leaderOTActualsFilterApplied = false;
      this.Allfilter.forEach((a, i) => { if (a.column == 'Leader_OT_Actuals') this.Allfilter.splice(i, 1) });
    }

    this.applyLocalFilter();

  }

  clearallFilter() {

    this.FundingSourceFilterApplied = false;
    this.SegmentFilterApplied = false;
    this.FundingOwnerFilterApplied = false;
    this.FundingSegmentFilterApplied = false;
    this.ucmgIdNameFilterApplied = false;
    this.ucmgNameFilterApplied = false;
    this.ucmg_countFilterApplied = false;
    this.flagged_ucmg_countFilterApplied = false;
    this.totalACAPFilterApplied = false;
    this.totalOTFilterApplied = false;
    this.acapFilterApplied = false;
    this.otlFilterApplied = false;
    this.otVarianceFilterApplied = false;
    this.advisoryServiceFilterApplied = false;
    this.businessLaborFilterApplied = false;
    this.hardwareSoftwareServiceApplied = false;
    this.otherChargebacksFilterApplied = false;
    this.professionalFeesFilterApplied = false;
    this.leaderOTAllocationApplied = false;
    this.leaderOTActualsFilterApplied = false;

    this.Allfilter = [];
    this.FundingSourceFilter = [];
    this.SegmentFilter = [];
    this.LobFilter = [];
    this.fundingOwnerFilter = [];
    this.ucmgIdNameFilter = [];
    this.ucmgNameFilter = [];
    this.ucmg_countFilter = [];
    this.flagged_ucmg_countFilter = [];
    this.totalACAPFilter = [];
    this.totalOTFilter = [];
    this.totalRunRateFilter = [];
    this.acapFilter = [];
    this.otlFilter = [];
    this.otVarianceFilter = [];
    this.advisoryServiceFilter = [];
    this.businessLaborFilter = [];
    this.hardwareSoftwareFilter = [];
    this.otherChargebacksFilter = [];
    this.professionalFeesFilter = [];
    this.leaderOTAllocationFilter = [];
    this.leaderOTActualsFilter = [];

    this.dataSource= new MatTableDataSource(this.olddatasource);
    this.dataSource.data.forEach(element => {
      element.expand = false;
    });
    this.dataSource = new MatTableDataSource(this.dataSource.data);
    this.dataSource.paginator = this.ucmgListTable ?  this.ListTablepaginator: this.paginator;
    this.dataSource.sort = this.sort;
    this.callCustomNumberFilterClear();
  }

  filterDropdown(column) { 
    this.searchValue = '';
    const index = this.getFilterIndex(column);
    
    this.closeOtherMenus(index);
    this.populateFilterList(column, index);
    
    this.filterList = new Set([...this.filterList]);
    this.filterLists = Array.from(this.filterList);
  }
  
  private getFilterIndex(column): number {
    let index: number;
    
    const columnKey = column.key;
    
    // Map column keys to indices based on currentTable
    const indexMap = this.getIndexMapForCurrentTable();
    
    if (indexMap[columnKey] !== undefined) {
      index = indexMap[columnKey];
      this.tableFilterIndicies[columnKey] = index;
      
      // Populate ucmgCountValues for numeric columns if needed
      if (this.isNumericColumn(columnKey)) {
        this.populateUcmgCountValues(columnKey);
      }
    }
    
    return index;
  }
  
  private getIndexMapForCurrentTable(): { [key: string]: number } {
    switch (this.currentTable) {
      case 'investment-summary':
        return {
          'Funding_Source': 0,
          'Funding_SegmentID': 1,
          'Funding_Segment': 2,
          'Funding_Owner': 3,
          'ucmg_count': 4,
          'flagged_ucmg_count': 5,
          'total_acap': 6,
          'total_OT': 7
        };
      
      case 'ucmg-leader-view':
        return {
          'Funding_Segment': 0,
          'UCMG_ID_Name': 1,
          'Leader_OT_Allocation': 2,
          'totalRunRate': 3,
          'Leader_OT_Actuals': 4,
          'OT_Variance': 5
        };
      
      case 'ucmg-segment-view':
        return {
          'UCMG_ID_Name': 0,
          'ACAP': 1,
          'Optum_Tech_Labour': 2,
          'OT_Variance': 3,
          'Leader_OT_Actuals': 4,
          'totalRunRate': 5
        };
      
      default:
        return {};
    }
  }
  
  private isNumericColumn(columnKey: string): boolean {
    const numericColumns = [
      'ucmg_count', 'flagged_ucmg_count', 'total_acap', 'total_OT',
      'ACAP', 'Optum_Tech_Labour', 'OT_Variance','totalRunRate' , 'Advisory_Service',
      'Bussiness_Labour', 'Hardware_Software', 'Other_Chargebacks',
      'Professional_Fees', 'Leader_OT_Allocation', 'Leader_OT_Actuals'
    ];
    return numericColumns.includes(columnKey);
  }
  
  private populateUcmgCountValues(columnKey: string) {
    if (this.olddatasource) {
      this.ucmgCountValues = this.olddatasource
        .map(row => row[columnKey])
        .filter(val => val !== undefined && val !== null);
    }
  }
  
  private closeOtherMenus(currentIndex: number) {
    (this.trigger?.toArray?.() ?? []).forEach((item: MatMenuTrigger, i: number) => {
      if (i !== currentIndex && item?.menu && item.menuOpen) {
        try { item.closeMenu(); } catch {}
      }
    });
  }
  
  private populateFilterList(column, index: number) {
    const columnKey = column.key;
    const filterMap = this.getFilterMapForColumn(columnKey);
    
    if (filterMap) {
      this.filterList = filterMap.list;
      this.filValue = filterMap.value;
      
      if (this.tableFilterIndicies[columnKey] !== undefined) {
        this.trigger.toArray()[this.tableFilterIndicies[columnKey]].openMenu();
      }
    }
  }
  
  private getFilterMapForColumn(columnKey: string): { list: any[], value: any[] } | null {
    switch (columnKey) {
      case 'Funding_SegmentID':
        return {
          list: this.dataSource.data.map(item => item.Funding_SegmentID),
          value: this.SegmentFilter
        };
      
      case 'Funding_Segment':
        return {
          list: this.dataSource.data.map(item => item.Funding_Segment),
          value: this.LobFilter
        };
      
      case 'Funding_Owner':
        return {
          list: this.getUniqueFundingOwners(),
          value: this.fundingOwnerFilter
        };
      
      case 'Funding_Source':
        return {
          list: this.dataSource.data.map(item => item.Funding_Source),
          value: this.FundingSourceFilter
        };
      
      case 'UCMG_ID_Name':
        return {
          list: this.dataSource.data.map(item => item.UCMG_ID_Name),
          value: this.ucmgIdNameFilter
        };
      
      default:
        return this.getNumericFilterMap(columnKey);
    }
  }
  
  private getUniqueFundingOwners(): string[] {
    const uniqueOwners = [];
    this.dataSource.data.filter(item => {
      if (item.Funding_Owner) {
        item.Funding_Owner.forEach(owner => {
          if (uniqueOwners.indexOf(owner) === -1) {
            uniqueOwners.push(owner);
          }
        });
      }
    });
    return uniqueOwners;
  }
  
  private getNumericFilterMap(columnKey: string): { list: any[], value: any[] } | null {
    const numericColumns = {
      'ucmg_count': this.ucmg_countFilter,
      'flagged_ucmg_count': this.flagged_ucmg_countFilter,
      'total_acap': this.totalACAPFilter,
      'total_OT': this.totalOTFilter,
      'totalRunRate': this.totalRunRateFilter,
      'ACAP': this.acapFilter,
      'Optum_Tech_Labour': this.otlFilter,
      'OT_Variance': this.otVarianceFilter,
      'Advisory_Service': this.advisoryServiceFilter,
      'Bussiness_Labour': this.businessLaborFilter,
      'Hardware_Software': this.hardwareSoftwareFilter,
      'Other_Chargebacks': this.otherChargebacksFilter,
      'Professional_Fees': this.professionalFeesFilter,
      'Leader_OT_Allocation': this.leaderOTAllocationFilter,
      'Leader_OT_Actuals': this.leaderOTActualsFilter
    };
    
    if (numericColumns[columnKey] !== undefined) {
      return {
        list: this.dataSource.data.map(item => item[columnKey]),
        value: numericColumns[columnKey]
      };
    }
    
    return null;
  }

  search(query: string) {
    const result = this.select(query)
    this.filterLists = result;
  }

  select(query: string): string[] {
    const result: string[] = [];
    for (const a of this.filterList) {
      if (a.toLowerCase().indexOf(query) > -1) {
        result.push(a)
      }
    }
    return result;
  }
  

  checkAllRowsExpanded() {
    if(this.expandElements.length > 0) 
      return true;
    else 
      return false;
  }

  collapseDetailRow(element) {
    this.expandElements.forEach((ele,index)=>{
      if(ele == element['id']) this.expandElements.splice(index,1);
    });
    element.expand = false;
    if(!this.checkAllRowsExpanded()) {
      this.collapseAllEvent(false);
    }
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  collapseAllEvent(data) {
    this.collapseAll.emit(data);
  }

  expandDetailRow(element,isExpand) { 
    if(element && element['id'] >=0){
      if(this.expandElements.indexOf(element['id'] == -1) ) {
        this.expandElements.push(element['id']);
      }
      element.expand = isExpand;
      this.collapseAllEvent(true);
      this.expandedElement = this.expandedElement === element ? null : element;
      this.cd.detectChanges();

      this.innerTables.forEach((table, index) => {
        ((table.dataSource as MatTableDataSource<any>).paginator = this.childpaginator.toArray()[index])
      });
    }
  }

  exportToCsv(){
    if (this.dataSource.data && this.dataSource.data.length) {
      const exportData = this.dataSource.data;
      const dataValues = [];
      exportData.map((ele) => {
          const obj: any = {};
          const funding_owner =  ele['Funding_Owner'] ? ele['Funding_Owner'][0]: null;
          obj['Funding Source'] = ele['Funding_Source'] ? ele['Funding_Source'] : '';
          obj['Funding Owner'] = funding_owner ? funding_owner : '';
          obj['Funding Segment ID'] = ele['Funding_SegmentID'] ? ele['Funding_SegmentID'] : '';
          obj['Funding Segment'] = ele['Funding_Segment'] ? ele['Funding_Segment'] : '';
          obj['UCMG Count'] = ele['ucmg_count'] ? ele['ucmg_count'] : '';
          obj['Flagged UCMG ID'] = this.convertToString(ele['flagged_ucmg_count']);
          obj['Fiscal Year'] = ele['fiscalYear'] ? ele['fiscalYear'] : '';
          obj['Total Forecast'] = ele['total_acap'] ? ele['total_acap'] : '';
          obj['Optum Tech Labor'] = this.convertToString(ele['total_OT']);
          obj['Investment Status'] = ele['investmentStatus'] ? ele['investmentStatus']:'';
          dataValues.push(obj);
          obj['Investment Status'] = ele['investmentStatus'] ? ele['investmentStatus']:'';
      });
      const fileName = 'Capital-Demand-Investment';
      this.exportService.exportToExcel(fileName, [dataValues],['Investment-list']);
    }
  }

  convertToString(value){
    let valueToReturn = '';
    if(value != null){
      valueToReturn = value.toString();
    }
    return valueToReturn
  }

  getEditUCMGUserRole(event) {
    try {
      this.editUCMGUserRole = '';
      // Funding_Admin for 'All' or for this segment
      if (this.sharedAuthService.getFundingAccessDetails('')) {
        this.editUCMGUserRole = "Funding_Admin";
        return;
      }
  
      // Funding_Owner for this segment
      if (this.sharedAuthService.getFundingAccessDetails(event.Funding_SegmentID, 'Funding_Owner')) {
        this.editUCMGUserRole = "Funding_Owner";
        return;
      }
  
      // Funding_Delegate for this segment
      if (this.sharedAuthService.getFundingAccessDetails(event.Funding_SegmentID, 'Funding_Delegate')) {
        this.editUCMGUserRole = "Funding_Delegate";
        return;
      }
  
      // No access for this segment
      this.editUCMGUserRole = '';
    } catch (err) {
      console.error('Error parsing fundingAccess', err);
      this.editUCMGUserRole = '';
    }
  }

  hasValidUCMGRole(event): boolean {
    this.getEditUCMGUserRole(event);
    return this.editUCMGUserRole === 'Funding_Admin' || this.editUCMGUserRole === 'Funding_Owner' || this.editUCMGUserRole === 'Funding_Delegate';
  }

  isFundingAdmin(event: any): boolean {
    try {
      this.getEditUCMGUserRole(event);
    } catch (error) {
      console.error('Error determining Funding_Admin role:', error);
      return false;
    }
    return this.editUCMGUserRole === 'Funding_Admin';
  }

  editUcmg(event){
    this.getEditUCMGUserRole(event);
    this.editUcmgData = JSON.parse(JSON.stringify(event));
    this.isEditUcmg = true;
    this.editUcmgModal.show();
    const element =<any>document.querySelector('.nav-color');
    if(element){element.style.zIndex=1;}
  }

  keyUpSearch(name, column) {
    const p: any = {}
    p['search'] = name.target.value;
    p['column'] = column;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    } else {
      column.options = [];
    }
  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(data => {
        column.options = [];
        data.forEach(element => {
          column.options.push({employeeID:element.employeeID,displayName:element.displayName,middleName:element.middleName,mail:element.mail, givenName: element.givenName, sn: element.sn, name: element.givenName + ' ' + element.sn, key: element.cn });
        });
      }, (error) => { 
        console.error(error);
      });

    } else {
      column.options = [];
    }
  }

  getNavigationLink(col: any, element: any): string {
    let queryParams: any = {};
    let path = '';
    switch (col.key) {
      case 'offeringId':
        path = '/technology-insights';
        queryParams = { offeringId: element[col.key] };
        break;

      case 'Funding_Segment':
      
        path = '/maintenanceV4/Capital-Demand/UCMG-List-View';
        queryParams = {
          segmentView: true,
          Funding_SegmentID: element['Funding_SegmentID'],
          invstStatus: element['investmentStatus'],
          fiscalYear: element['fiscalYear'],
          ucmgId:this.searchedUcmgId  ? element['UCMG_ID'] : '',
        };
        break;

      default:
        return '#';
    }

    const tree = this.router.createUrlTree([path], { queryParams });
    return this.router.serializeUrl(tree);
  }

  getNavLinkToUCMG(element: any) {
      const queryParams = {
          segmentView: 'true',
          Funding_SegmentID: element['Funding_SegmentID'],
          invstStatus: element['investmentStatus'],
          fiscalYear: element['fiscalYear'],
          ucmgYear: JSON.stringify(this.ucmgYear),
          selectedStatus: JSON.stringify(this.selectedStatusList),
          searchedText: this.searchedText ? this.searchedText : '',
      };
      this.router.navigate(['/maintenanceV4/Capital-Demand/UCMG-List-View'], { queryParams });
  }

  fundOwnerRestrictionEdit() {
    this.restrictionInvesterEdit = this.sharedAuthService.getFundingAccessDetails('');
  }

  dataRefreshAfterSave(event){
    this.dataRefresh.emit(event);
  }

  formatMoney(amount, decimals?: number) {
    // Check if the amount is valid
    if (!amount) {
      return "";
    } else {
      const precision = decimals ?? 0;
      // Format the amount to the requested decimal places (0 by default)
      amount = parseFloat(amount).toFixed(precision);
      // Split the amount into integer and decimal parts
      const parts = amount.split(".");
      // Add commas to the integer part
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // Check if the decimal part is .00
      if (parts[1] === "00") {
          return "$" + parts[0];
      } else {
          // Join the integer and decimal parts
          return "$" + parts.join(".");
      }
    }
  }

  clearAllNumberFilters(exceptKey?: string) {
    const filters = [
      'ucmg_count', 'flagged_ucmg_count', 'total_acap', 'total_OT',
      'ACAP', 'Optum_Tech_Labour', 'OT_Variance', 'Advisory_Service',
      'Bussiness_Labour', 'Hardware_Software', 'Other_Chargebacks',
      'Professional_Fees', 'Leader_OT_Allocation'
    ];
    filters.forEach(key => {
      if (key !== exceptKey) {
        this[`${key}Filter`] = [];
        this[`${key}FilterApplied`] = false;
        // Remove from Allfilter array
        this.Allfilter = this.Allfilter.filter(f => f.column !== key);
      }
    });
      this.ucmg_countFilter = [];
      this.flagged_ucmg_countFilter = [];
      this.totalACAPFilter = [];
      this.totalOTFilter = [];
      this.totalRunRateFilter = [];
      this.acapFilter = [];
      this.otVarianceFilter = [];
      this.advisoryServiceFilter = [];
      this.businessLaborFilter = [];
      this.hardwareSoftwareFilter = [];
      this.otherChargebacksFilter = [];
      this.professionalFeesFilter = [];
      this.leaderOTAllocationFilter = [];
      this.otlFilter = [];
      //non number filters
      this.ucmgIdNameFilter = [];
      this.FundingSourceFilter = [];
      this.SegmentFilter = [];
      this.LobFilter = [];
      this.fundingOwnerFilter = [];
  

      this.ucmg_countFilterApplied = false;
      this.flagged_ucmg_countFilterApplied = false;
      this.totalACAPFilterApplied = false;
      this.totalOTFilterApplied = false;
      this.otlFilterApplied = false;
      this.otVarianceFilterApplied = false;
      this.advisoryServiceFilterApplied = false;
      this.businessLaborFilterApplied = false;
      this.hardwareSoftwareServiceApplied = false;
      this.otherChargebacksFilterApplied = false;
      this.professionalFeesFilterApplied = false;
      this.leaderOTAllocationApplied = false;
      //non number filters
      this.ucmgIdNameFilterApplied = false;
      this.FundingSourceFilterApplied = false;
      this.SegmentFilterApplied = false;
      this.FundingSegmentFilterApplied = false;
      this.FundingOwnerFilterApplied = false;
      this.Allfilter = this.Allfilter.filter(a => a.column === exceptKey);
  }

  callCustomNumberFilterClear() {
    if (this.customNumbersAutoFilters) {
      this.customNumbersAutoFilters.forEach(filter => filter.onClearClick());
    }
  }
}